import * as React from "react";
import { useFormContext } from "react-hook-form";
import { Form, Label } from "semantic-ui-react";

import { CustomerListModel } from "../../customer";
import { EmployeeRecordFormModel } from "../schema";

import { CreateEditEmployee } from "./CreateEditEmployee";

interface Props {
    initialModel: EmployeeRecordFormModel;
    customer: CustomerListModel;
}

export const EditEmployeeForm = ({ initialModel, customer }: Props) => {
    const { register, formState: { errors } } = useFormContext<EmployeeRecordFormModel>();
    return (
        <>
            <Form.Field>
                {errors.personalReferenceNumber?.message && (<Label pointing="below" color="red">{errors.personalReferenceNumber.message}</Label>)}
                <label>Personal Reference Number</label>
                <input {...register("personalReferenceNumber")} />
            </Form.Field>
            <Form.Field>
                {errors.legacyPersonalId?.message && (<Label pointing="below" color="red">{errors.legacyPersonalId.message}</Label>)}
                <label>Legacy ID</label>
                <input {...register("legacyPersonalId")} />
            </Form.Field>
            <CreateEditEmployee initialModel={initialModel} customer={customer} />
        </>
    );
};
